<template>
  <div>
    <main class="main-content">
      <div class="card">
        <div class="card-body">
          <h6 class="card-title">ارسال پیامک</h6>
          <form class="border" @submit.prevent="onSubmit" @keydown="form.errors.clear($event.target.name)">
            <div class="d-flex justify-content-center pt-4">
              <div class="col-5">
                <button type="button" :class="[ butt=='staff' ? 'btn btn-outline-primary btn-block active' : 'btn btn-outline-primary btn-block']" @click="butt='staff'">کارمندان</button>
              </div>
              <div class="col-5">
                <button type="button" :class="[ butt=='installer' ? 'btn btn-outline-success btn-block active' : 'btn btn-outline-success btn-block']" @click="butt='installer'">نصابان</button>
              </div>
            </div>
            <div class="d-flex justify-content-center py-4">
              <div class="col-5">
                <button type="button" :class="[ butt=='customer' ? 'btn btn-outline-warning btn-block active' : 'btn btn-outline-warning btn-block']" @click="butt='customer'">مشتریان</button>
              </div>
              <div class="col-5">
                <button type="button" :class="[ butt=='manual' ? 'btn btn-outline-dark btn-block active' : 'btn btn-outline-dark btn-block']" @click="butt='manual'">وارد کردن شماره به صورت دستی</button>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center" v-if="butt=='staff'">
              <div class="col-md-10 mb-3">
                <label for="validationCustom01">کارمندان
                    <span class="text-danger">*</span>
                </label>
                <v-select multiple v-model="form.phone" :options="users" name="phone" label="name" :select-on-key-codes="form.errors.clear('phone')" v-if="users"></v-select>
                <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
              </div>
            </div>
            <div v-else-if="butt=='customer'">
              <div class="form-row d-flex justify-content-center">
                <div class="col-md-10 mb-3">
                  <label for="validationCustom01">جستجو بر اساس موبایل و اسم مشتری
                      <span class="text-danger">*</span>
                  </label>
                  <input type="text" class="form-control" placeholder="موبایل یا اسم راوارد کنید" @keyup="debounceInput" v-model="searchkey">
                </div>
              </div>
              <div class="form-row d-flex justify-content-center" v-if="customers">
                <div class="col-md-10 mb-3">
                  <label for="validationCustom01">مشتریان
                      <span class="text-danger">*</span>
                  </label>
                  <v-select multiple v-model="form.phone" :options="customers" name="phone" label="phoneName" :select-on-key-codes="form.errors.clear('phone')"></v-select>
                  <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
                </div>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center" v-else-if="butt=='installer'">
              <div class="col-md-10 mb-3">
                <label for="validationCustom01">نصابان
                    <span class="text-danger">*</span>
                </label>
                <v-select multiple v-model="form.phone" :options="installers" name="phone" label="name" :select-on-key-codes="form.errors.clear('phone')" v-if="installers"></v-select>
                <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center" v-else-if="butt=='manual'">
              <div class="col-md-10 mb-3">
                <label for="validationCustom01">شماره موبایل
                    <span class="text-danger">*</span>
                </label>
                <input type="nubmer" class="form-control" placeholder="شماره تلفن را وارد کنید" name="phone" v-model="form.phone">
                <span class="help text-danger" v-if="form.errors.has('phone')" v-text="form.errors.get('phone')"></span>
              </div>
            </div>
            <div class="form-row d-flex justify-content-center">
              <div class="col-md-10 mb-3">
                <label for="validationCustom01">متن پیام
                    <span class="text-danger">*</span>
                </label>
                <textarea type="text" class="form-control" placeholder="متن پیام را وارد کنید!" name="message" v-model="form.message"></textarea>
                <span class="help text-danger" v-if="form.errors.has('message')" v-text="form.errors.get('message')"></span>
              </div>
            </div>
              <div class="btn-group d-flex justify-content-center">
                <div class="col-5">
                  <button class="btn btn-success btn-block btn-pulse" type="submit" :disabled="form.errors.any()">ذخیره</button>
                </div>
                 <div class="col-5">
                  <router-link :to="{name: 'permissions.index'}" class="btn btn-dark btn-block" type="button"><span
                  class="text-white">بازگشت</span></router-link>
                </div>
              </div>
          </form>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'SmsSend',
  data () {
    return {
      form: new this.$form({
        phone: '',
        message: '',
        type: ''
      }),
      butt: null,
      users: null,
      installers: null,
      customers: null,
      searchkey: null
    }
  },
  watch: {
    butt: function (val) {
      this.form.type = val
    }
  },
  beforeMount () {
    this.$send.submit('get', 'api/project/getUsers')
      .then(response => {
        this.users = response
      })
    this.$send.submit('get', 'api/get/installers')
      .then(response => {
        this.installers = response
      })
  },
  methods: {
    onSubmit () {
      this.$send.submit('post', '/api/sms/send/messeage', this.form.data())
        .then(response => {
          this.form.onSuccess(response)
          // eslint-disable-next-line no-undef
          swal(
            'تبریک!',
            ' پیامک با موفقیت ارسال شد!',
            'success'
            , {
              button: 'باشه'
            })
          this.$router.push({ name: 'sms.index' })
        }).catch(error => {
          this.form.onFail(error.errors)
        })
    },
    debounceInput: _.debounce(function () {
      this.search()
    }, 800),
    search () {
      this.$send.submit('post', 'api/sms/search/customer', { search: this.searchkey })
        .then(response => {
          this.customers = response
        })
    }
  }
}

</script>
